import axios from 'axios';

// Chave utilizada para armazenar o token no localStorage (deve ser a mesma do AuthContext)
const TOKEN_STORAGE_KEY = '@MagaluEnvironmentControl:token';

// Em produção, URL vazia = mesma origem (evita mixed-content após HTTPS no domínio).
const api = axios.create({
  baseURL:
    import.meta.env.VITE_API_URL ||
    (import.meta.env.DEV ? 'http://localhost:3000' : ''),
});

// Interceptor para adicionar o token JWT às requisições
api.interceptors.request.use(
  async (config) => {
    // Correção: Verificar se a URL relativa é exatamente '/api/login'
    const isLoginRequest = config.url === '/api/login';

    if (isLoginRequest) {
      return config;
    }

    // Se não for login, tenta adicionar o token
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;